<template>
  <transition :css="false" :appear="appears" @enter="enter" @leave="leave">
    <div
      class="ProductSlide"
      ref="slide"
    >
      <div class="ProductSlide-top">
        <h1 ref="title">{{ product.title }}</h1>
        <img ref="image" :src="image" class="ProductSlide-image" />
      </div>
      <div>
        <p
          class="ProductSlide-description"
          ref="description"
          v-html="product.description"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { images } from "@/data/productsImages";
import gsap, { TweenMax } from "gsap";

export default {
  props: {
    index: Number,
    product: Object,
    animDirection: String,
  },
  computed: {
    image() {
      const { product } = this;
      return images[product.id];
    },
    elems() {
      const { $refs } = this;
      return [$refs.title, $refs.image, $refs.description, $refs.linkSix];
    },
    appears() {
      const { index } = this;
      return index === 0;
    },
  },
  methods: {
    enter(el, done) {
      const { animDirection, elems } = this;
      const x = animDirection == "right" ? "15%" : "-15%";

      gsap.fromTo(
        elems,
        {
          x,
          alpha: 0,
        },
        {
          x: 0,
          alpha: 1,
          delay: 0.5,
          stagger: 0.075,
          ease: "power3.out",
          onComplete: done,
          duration: 0.7,
        },
      );
    },
    leave(el, done) {
      const { animDirection, elems } = this;
      const x = animDirection == "right" ? "-15%" : "15%";
      const _elems = elems;
      /*
      if (animDirection == "left") {
        for (let i = 0; i < Math.floor(_elems.length / 2); i++) {
          [_elems[i], _elems[_elems.length - 1 - i]] = [_elems[_elems.length - 1 - i], _elems[i]];
        }
      }
      */

      TweenMax.to(_elems, 0.75, {
        x,
        alpha: 0,
        stagger: 0.05,
        ease: "power3.inOut",
        onComplete: () => {
          gsap.set(el, { clearProps: "all" });
          done();
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './ProductSlide.styl';
</style>
